<template>
  <div class="progress" :style="progressStyle" @click="$emit('click', $event)">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BProgress',
  props: {
    max: { type: Number, default: 100 },
    height: { type: String, default: null },
    showValue: { type: Boolean, default: false },
    precision: { type: Number, default: 0 },
    striped: { type: Boolean, default: false }
  },
  computed: {
    progressStyle() {
      const style = {}
      if (this.height) style.height = this.height
      return style
    }
  },
  provide() {
    return {
      progressMax: this.max
    }
  }
}
</script>

<style scoped>
.progress {
  border-radius: 4px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(0,0,0,0.06) 0%, rgba(0,0,0,0.02) 100%);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.12),
              0 1px 0 rgba(255, 255, 255, 0.6);
}
</style>
